/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side layout! *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * layout behavior, you should modify: ../MobileCommControlNotificationTable.ts *
 *                                                                             *
/*******************************************************************************/

import { Layout } from "@mcleod/components";

export class AutogenLayoutMobileCommControlNotificationTable extends Layout {

	// Table components
	tableMCDriverNotification: any;

	// Cell components
	textboxNotificationType: any;
	textboxDaysToNotify: any;
	switchEnabled: any;
	textboxRepeatFrequency: any;

	// Data sources
	sourceMCDriverNotification: any;

	async onLoad() {
		await super.onLoad();
	}
}
